import { type IconsType } from "@/types/iconsType";
import type {
  GlobalSettingsType,
  NotificationType,
  FAQType,
  ExtraPackType,
  ExtraPackMoreType,
  MaintenanceType,
} from "@/types";

type dashboardNavigationType = {
  title: string;
  query: string;
  iconName: IconsType | string;
  fontAwesomeIcon?: boolean;
};

interface MainState {
  theme: string;
  showMobileNavigation: boolean;
  dashboardNavigation: dashboardNavigationType[];
  dashboardNavigationMobile: dashboardNavigationType[];
  globalSettings: GlobalSettingsType | null;
  notifications: NotificationType[];
  faqs: FAQType[];
  extraPacks: ExtraPackType[];
  extraPacksMore: ExtraPackMoreType[];
  selectedMsn: string | null;
  returnUrl: string | null;
  selectedCard: any;
  maintenance: MaintenanceType | null;
  qrCodeImageUrl: string | null;
}

export const useMainStore = defineStore("useMainStore", {
  state: (): MainState => ({
    theme: "personal",
    selectedMsn: null,
    returnUrl: null,
    selectedCard: null,
    showMobileNavigation: false,
    dashboardNavigation: [
      {
        title: "my plans",
        query: "?view=my-plans",
        iconName: "sim_card",
      },
      {
        title: "extras & roaming",
        query: "?view=extra-roaming",
        iconName: "add_circle_outline",
      },
      {
        title: "personal details",
        query: "?view=personal-details",
        iconName: "person",
      },
      {
        title: "my orders",
        query: "?view=orders",
        iconName: "shopping_cart",
      },
      // Recharge history removed as it's now part of service detail view
      {
        title: "addresses",
        query: "?view=address",
        iconName: "location_on",
      },
      {
        title: "saved cards",
        query: "?view=saved-cards",
        iconName: "credit_card",
      },
      {
        title: "communication preferences",
        query: "?view=comms-preferences",
        iconName: " subscriptions ",
      },
      {
        title: "logout",
        query: "",
        iconName: "exit_to_app ",
      },
    ],
    dashboardNavigationMobile: [
      {
        title: "my service",
        query: "?view=my-plans",
        iconName: "phone_iphone",
      },
      {
        title: "extras & roaming",
        query: "?view=extra-roaming",
        iconName: "add_circle_outline",
      },
      {
        title: "my orders",
        query: "?view=orders",
        iconName: "shopping_cart",
      },
      {
        title: "my recharges",
        query: "?view=recharge-history",
        iconName: "history",
      },
      {
        title: "my payment methods",
        query: "?view=saved-cards",
        iconName: "credit_card",
      },
      {
        title: "my addresses",
        query: "?view=address",
        iconName: "contact_mail",
      },
      {
        title: "personal details",
        query: "?view=personal-details",
        iconName: "portrait",
      },
      {
        title: "communication preferences",
        query: "?view=comms-preferences",
        iconName: "subscriptions",
      },
      {
        title: "logout",
        query: "",
        iconName: "exit_to_app",
      },
    ],
    globalSettings: null,
    notifications: [],
    faqs: [],
    extraPacks: [],
    extraPacksMore: [],
    maintenance: null,
    qrCodeImageUrl: null,
  }),
  getters: {
    getGlobalSettings: (state) => state.globalSettings,
    getNotifications: (state) => state.notifications,
    getFaqs: (state) => state.faqs,
    getExtraPacks: (state) => state.extraPacks,
    getExtraPacksMore: (state) => state.extraPacksMore,
    getSelectedMsn: (state) => state.selectedMsn,
    getReturnUrl: (state) => state.returnUrl,
    getSelectedCard: (state) => state.selectedCard,
    getMaintenance: (state) => state.maintenance,
  },
  actions: {
    toggleMobileNavigation() {
      this.showMobileNavigation = !this.showMobileNavigation;
    },
    updateGlobalSettings(settings: GlobalSettingsType | null) {
      if (!settings) {
        return;
      }
      this.globalSettings = settings;
    },
    updateMaintenance(maintenance: MaintenanceType | null) {
      if (!maintenance) {
        return;
      }
      this.maintenance = maintenance;
    },
    setNotifications(notifications: NotificationType[]) {
      this.notifications = notifications;
    },
    setFaqs(faqs: FAQType[]) {
      this.faqs = faqs;
    },
    setExtraPacks(extraPacks: ExtraPackType[]) {
      this.extraPacks = extraPacks;
    },
    setExtraPacksMore(extraPacksMore: ExtraPackMoreType[]) {
      this.extraPacksMore = extraPacksMore;
    },
    setSelectedMsn(msn: string | null) {
      this.selectedMsn = msn;
    },
    setReturnUrl(returnUrl: string | null) {
      this.returnUrl = returnUrl;
    },
    setSelectedCard(card: any) {
      this.selectedCard = card;
    },
    setQrCodeImageUrl(url: string | null) {
      this.qrCodeImageUrl = url;
    },
  },
});
